import VContextMenu from "@/components/VContextMenu";

// assets
import copyIcon from "@/assets/images/context-menu/copy.svg";
import copyIconActive from "@/assets/images/context-menu/copy-active.svg";
import duplicateIcon from "@/assets/images/context-menu/duplicate.svg";
import duplicateIconActive from "@/assets/images/context-menu/duplicate-active.svg";
import renameIcon from "@/assets/images/context-menu/rename.svg";
import renameIconActive from "@/assets/images/context-menu/rename-active.svg";
import removeIcon from "@/assets/images/context-menu/remove.svg";
import removeIconActive from "@/assets/images/context-menu/remove-active.svg";
import resendIcon from "@/assets/images/context-menu/resend.svg";
import resendIconActive from "@/assets/images/context-menu/resend-active.svg";

/**
 * Helper to get actions for context menu by providing handlers.
 *
 * Returns only elements with provided functions as a value within { key: value } pair.
 * @param handlers
 * @param props
 * @returns {{handler: *}[]}
 */
export const getContextMenuActions = (handlers, props = {}) => {
  const handlersKeys = Object.keys(handlers);

  if (!handlersKeys.length) {
    throw Error("Can't use empty context menu!");
  }

  const actionMap = {
    rename: {
      iconSrc: renameIcon,
      iconSrcActive: renameIconActive,
      id: "rename",
      title: "Rename"
    },

    copy: {
      id: "copy",
      iconSrc: copyIcon,
      iconSrcActive: copyIconActive,
      title: "Copy ID"
    },

    duplicate: {
      id: "duplicate",
      iconSrc: duplicateIcon,
      iconSrcActive: duplicateIconActive,
      title: "Duplicate"
    },

    remove: {
      id: "delete",
      iconSrc: removeIcon,
      iconSrcActive: removeIconActive,
      title: "Delete"
    },

    resend: {
      id: "resend",
      iconSrc: resendIcon,
      iconSrcActive: resendIconActive,
      title: "Resend"
    }
  };

  return handlersKeys.filter(key => handlers[key]).map(key => ({
    ...actionMap[key],
    handler: handlers[key],
    ...props
  }));
};

/**
 * Context menu object for Data Table
 * @param handlers - Object with keys and handlers for them
 * @param outerProps - additional props
 *
 * default kit: rename, copy, duplicate, remove
 */
export const getTableContextMenu = (handlers, outerProps = {}) => ({
  key: "v-context-menu",
  component: VContextMenu,
  props: {
    actions: getContextMenuActions(handlers)
  },
  extraClass: "context-menu",
  ...outerProps
});
